import React from 'react';

const NotFound = () => {
    return (
        <div className='mt-4'>
            <h1 className="text-center text-white bg-danger fw-bold p-2">Sorry, This page is not available Right Now.</h1>
        </div>
    );
};

export default NotFound;